import { AsyncPipe, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatError, MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatLabel } from '@angular/material/select';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { APPLICATION_TYPE } from '@core';
import { Store } from '@ngrx/store';
import { AuthActions, AuthSelectors } from '@ngrx-store';
import { MainLogoComponent } from '@ui';
import { Observable } from 'rxjs';

import { emailValidationPattern } from '../../constants';

@Component({
  imports: [
    MainLogoComponent,
    MatCard,
    MatCardContent,
    MatFormField,
    ReactiveFormsModule,
    MatIcon,
    AsyncPipe,
    MatSuffix,
    MatProgressSpinner,
    UpperCasePipe,
    MatInput,
    MatPrefix,
    MatLabel,
    MatError,
    RouterLink,
    NgTemplateOutlet,
  ],
  selector: 'avs-li-forgot-password',
  standalone: true,
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  protected form: FormGroup;
  protected appType = inject(APPLICATION_TYPE);
  protected isMobile = signal(false);
  protected isLoading$: Observable<boolean | undefined>;
  protected instructionsSent = false;

  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private store = inject(Store);

  constructor() {
    this.isMobile.set(this.appType === 'mobile');
    this.instructionsSent = this.route.snapshot.paramMap.get('state') === 'success';
    this.form = this.fb.group({
      email: new FormControl(
        {
          disabled: false,
          value: '',
        },
        [Validators.required, Validators.pattern(emailValidationPattern)],
      ),
    });
    this.isLoading$ = this.store.select(AuthSelectors.isLoading);
  }

  protected sendEmail() {
    if (this.form.valid) {
      this.store.dispatch(AuthActions.forgotPassword({ email: this.form.value.email }));
    } else {
      this.form.markAllAsTouched();
    }
  }
}
